import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import Logo from "../components/Logo";
import { GoogleLogo, ArrowLeft, ShieldCheck } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      {/* Left: form */}
      <div className="flex flex-col">
        <div className="px-6 lg:px-10 h-16 flex items-center justify-between border-b border-border">
          <Logo />
          <Link to="/" className="text-xs text-muted-foreground hover:text-foreground inline-flex items-center gap-1.5" data-testid="back-to-home-link">
            <ArrowLeft size={14}/> Back to site
          </Link>
        </div>
        <div className="flex-1 flex items-center justify-center px-6 py-16">
          <div className="w-full max-w-sm">
            <div className="eos-overline mb-3">Sign in</div>
            <h1 className="font-heading font-extrabold text-4xl tracking-tight leading-tight">
              Welcome back to<br/>the workspace.
            </h1>
            <p className="text-sm text-muted-foreground mt-3">Use your institutional Google account. We'll set up your role next.</p>
            <Button
              onClick={handleGoogle}
              className="mt-8 w-full h-12 rounded-md bg-white border border-border hover:bg-secondary text-foreground"
              data-testid="google-signin-btn"
            >
              <GoogleLogo size={20} weight="bold" className="mr-2"/> Continue with Google
            </Button>
            <div className="mt-6 flex items-center gap-2 text-[11px] text-muted-foreground">
              <ShieldCheck size={14} weight="bold" className="text-[hsl(20_90%_48%)]"/>
              Aadhaar e-KYC verification will run on first student account.
            </div>
            <div className="mt-12 text-[11px] text-muted-foreground leading-relaxed">
              By signing in you agree to the EduOS Terms and Data Processing Agreement
              (DPDP Act compliant, region-pinned to ap-south-1).
            </div>
          </div>
        </div>
      </div>
      {/* Right: pitch */}
      <div className="hidden lg:flex relative bg-[hsl(244_53%_20%)] text-white p-12 flex-col justify-between">
        <div className="absolute inset-0 eos-grid-lines opacity-10"/>
        <div className="relative">
          <div className="eos-overline text-white/50">Operating system</div>
          <div className="font-heading text-3xl font-bold tracking-tight mt-3 leading-tight">
            From first inquiry<br/>to lifelong alumni — one record.
          </div>
        </div>
        <div className="relative space-y-6">
          <blockquote className="text-lg font-heading font-medium leading-snug">
            "We retired five legacy systems in 90 days. NIRF data prep dropped from 6 weeks to 4 days."
          </blockquote>
          <div className="text-xs text-white/60">— Registrar, Tier-1 Engineering Institute (Pilot)</div>
        </div>
      </div>
    </div>
  );
}
